import { ReducerPaths } from '$store/constants/reducerPaths';
import { CandidateData } from '$types/candidates';
import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { PositionState } from './position.types';

const initialState: PositionState = {
  allCandidates: [],
  selectedCandidate: undefined,
  isLoadingIframe: false,
  openFeedbackModal: false,
  openFullSPKProfile: false,
  openNotAFitModal: false,
  openConfirmationInterviewModal: false,
  openInterviewCalendarModal: false,
  openInterviewRequestedModal: false,
};

export const singlePositionSlice = createSlice({
  name: ReducerPaths.POSITION,
  initialState,
  reducers: {
    setAllCandidates: (state, action: PayloadAction<CandidateData[]>) => {
      state.allCandidates = [...action.payload];
    },
    setSelectedCandidate: (
      state,
      action: PayloadAction<CandidateData | undefined>
    ) => {
      state.selectedCandidate = action.payload;
    },
    showNextCandidate: (state) => {
      const { allCandidates, selectedCandidate } = current(state);
      if (!allCandidates || allCandidates.length <= 1 || !selectedCandidate)
        return;

      const currentCandidateIndex = allCandidates?.findIndex(
        (singleCandidate) => singleCandidate.Id === selectedCandidate.Id
      );

      if (
        currentCandidateIndex !== -1 &&
        currentCandidateIndex < allCandidates.length - 1
      ) {
        state.selectedCandidate = allCandidates[currentCandidateIndex + 1];
      } else {
        state.selectedCandidate = allCandidates[0] || undefined;
      }

      state.isLoadingIframe = true;
    },
    showPreviousCandidate: (state) => {
      const { allCandidates, selectedCandidate } = current(state);
      if (!allCandidates || allCandidates.length <= 1 || !selectedCandidate)
        return;

      const currentCandidateIndex = allCandidates?.findIndex(
        (singleCandidate) => singleCandidate.Id === selectedCandidate.Id
      );

      if (currentCandidateIndex !== -1 && currentCandidateIndex > 0) {
        state.selectedCandidate = allCandidates[currentCandidateIndex - 1];
      } else {
        state.selectedCandidate =
          allCandidates[allCandidates.length - 1] || undefined;
      }

      state.isLoadingIframe = true;
    },
    setIsLoadingIframe: (state, action) => {
      state.isLoadingIframe = action.payload;
    },
    setOpenFeedbackModal: (state, action) => {
      state.openFeedbackModal = action.payload;
    },
    setOpenFullSPKProfile: (state, action) => {
      state.openFullSPKProfile = action.payload;
    },
    setOpenNotAFitModal: (state, action) => {
      state.openNotAFitModal = action.payload;
    },
    setOpenConfirmationInterviewModal: (state, action) => {
      state.openConfirmationInterviewModal = action.payload;
    },
    setOpenInterviewCalendarModal: (state, action) => {
      state.openInterviewCalendarModal = action.payload;
    },
    setOpenInterviewRequestedModal: (state, action) => {
      state.openInterviewRequestedModal = action.payload;
    },
  },
});
